/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FormPageButtonExternalLinkAllOf { 
    /**
     * 遷移する外部サイトのURL
     */
    siteUrl: string;
    /**
     * 遷移時のターゲット指定 HTMLの target指定と同一のものを定義している 
     */
    target: FormPageButtonExternalLinkAllOf.TargetEnum;
}
export namespace FormPageButtonExternalLinkAllOf {
    export type TargetEnum = '_blank' | '_self' | '_top' | '_parent';
    export const TargetEnum = {
        Blank: '_blank' as TargetEnum,
        Self: '_self' as TargetEnum,
        Top: '_top' as TargetEnum,
        Parent: '_parent' as TargetEnum
    };
}



